/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMcpServerSecurity = {
  option1?: GetMcpServerSecurityOption1 | undefined;
  option2?: GetMcpServerSecurityOption2 | undefined;
};

export type GetMcpServerRequest = {
  /**
   * The ID of the MCP server. Mutually exclusive with slug.
   */
  id?: string | undefined;
  /**
   * The slug of the MCP server. Mutually exclusive with id.
   */
  slug?: string | undefined;
  /**
   * Resolve the preferred MCP server for this toolset. Mutually exclusive with id and slug.
   */
  toolsetId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMcpServerSecurityOption1$Outbound,
  GetMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMcpServerSecurityOption1ToJSON(
  getMcpServerSecurityOption1: GetMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    GetMcpServerSecurityOption1$outboundSchema.parse(
      getMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMcpServerSecurityOption2$Outbound,
  GetMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMcpServerSecurityOption2ToJSON(
  getMcpServerSecurityOption2: GetMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    GetMcpServerSecurityOption2$outboundSchema.parse(
      getMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMcpServerSecurity$Outbound = {
  Option1?: GetMcpServerSecurityOption1$Outbound | undefined;
  Option2?: GetMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMcpServerSecurity$outboundSchema: z.ZodMiniType<
  GetMcpServerSecurity$Outbound,
  GetMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMcpServerSecurityToJSON(
  getMcpServerSecurity: GetMcpServerSecurity,
): string {
  return JSON.stringify(
    GetMcpServerSecurity$outboundSchema.parse(getMcpServerSecurity),
  );
}

/** @internal */
export type GetMcpServerRequest$Outbound = {
  id?: string | undefined;
  slug?: string | undefined;
  toolset_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMcpServerRequest$outboundSchema: z.ZodMiniType<
  GetMcpServerRequest$Outbound,
  GetMcpServerRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    slug: z.optional(z.string()),
    toolsetId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolsetId: "toolset_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMcpServerRequestToJSON(
  getMcpServerRequest: GetMcpServerRequest,
): string {
  return JSON.stringify(
    GetMcpServerRequest$outboundSchema.parse(getMcpServerRequest),
  );
}
